import { NavLink } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { observarFila, sincronizar, dispensarDescartado, eDoUsuario } from '../offline.js'
import { useSessao } from '../sessao.jsx'
import { emDataHora, emKm, emNumero, unidadeDaEnergia } from './basicos.jsx'

const Icone = ({ children }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
       strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    {children}
  </svg>
)

const ABAS = [
  { para: '/', rotulo: 'Início', icone: <path d="M3 11l9-8 9 8v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /> },
  { para: '/abastecer', rotulo: 'Abastecer', icone: <><path d="M12 5v14" /><path d="M5 12h14" /></> },
  { para: '/garagem', rotulo: 'Garagem', icone: <><path d="M5 17h14" /><path d="M6 17v-5l2-5h8l2 5v5" /></> },
  { para: '/config', rotulo: 'Mais', icone: <><circle cx="12" cy="12" r="3" /><path d="M12 3v2M12 19v2M3 12h2M19 12h2" /></> },
]

const POR_QUE_PAROU = {
  rede: 'o servidor não respondeu',
  sessao: 'a sessão expirou — entre de novo para enviar',
  servidor: 'o servidor está com problema; tente daqui a pouco',
}

/**
 * Faixa de estado: sem conexão, lançamentos esperando envio e lançamentos que o
 * servidor recusou. Os recusados ficam aqui até a pessoa dispensar — antes, a
 * fila os jogava fora em silêncio, e o lançamento simplesmente não existia.
 */
function FaixaEstado() {
  const { usuario } = useSessao()
  const [estado, setEstado] = useState({ fila: [], descartados: [] })
  const [online, setOnline] = useState(navigator.onLine)
  const [parada, setParada] = useState(null)
  const [enviando, setEnviando] = useState(false)

  useEffect(() => {
    const parar = observarFila(setEstado)
    const mudou = () => setOnline(navigator.onLine)
    window.addEventListener('online', mudou)
    window.addEventListener('offline', mudou)
    return () => {
      parar()
      window.removeEventListener('online', mudou)
      window.removeEventListener('offline', mudou)
    }
  }, [])

  const meus = (lista) => (usuario ? lista.filter((item) => eDoUsuario(item, usuario.id)) : [])
  const pendentes = meus(estado.fila).length
  const descartados = meus(estado.descartados)

  if (online && pendentes === 0 && descartados.length === 0) return null

  async function enviarAgora() {
    setEnviando(true)
    try {
      setParada((await sincronizar(usuario.id)).parada)
    } finally {
      setEnviando(false)
    }
  }

  return (
    <div className="faixas">
      {(!online || pendentes > 0) && (
        <div className="faixa-offline" role="status">
          {!online
            ? `Sem conexão${pendentes ? ` · ${pendentes} lançamento(s) guardado(s) no aparelho` : ''}`
            : `${pendentes} lançamento(s) aguardando envio`}
          {online && parada && ` — ${POR_QUE_PAROU[parada]}`}
          {online && pendentes > 0 && (
            <>
              {' '}
              <button type="button" className="botao-fantasma" style={{ minHeight: 0, padding: '2px 8px' }}
                      disabled={enviando} onClick={enviarAgora}>
                {enviando ? 'Enviando…' : 'Enviar agora'}
              </button>
            </>
          )}
        </div>
      )}

      {descartados.map((d) => (
        <div key={d.idempotency_key} className="faixa-offline faixa-recusado" role="alert">
          <strong>Lançamento recusado pelo servidor:</strong>{' '}
          {[
            emDataHora(d.inicio),
            d.quantidade !== undefined && `${emNumero(d.quantidade)} ${unidadeDaEnergia(d.energia)}`,
            d.medidor_final !== undefined && `relógio em ${emNumero(d.medidor_final, 3)} kWh`,
            emKm(d.odometro),
          ].filter(Boolean).join(' · ')}. {d.motivo} Lance de novo com os dados corrigidos.{' '}
          <button type="button" className="botao-fantasma" style={{ minHeight: 0, padding: '2px 8px' }}
                  onClick={() => dispensarDescartado(d.idempotency_key)}>
            Entendi
          </button>
        </div>
      ))}
    </div>
  )
}

export default function Layout({ titulo, acao, children }) {
  return (
    <div className="app">
      <header className="cabecalho">
        <h1>{titulo}</h1>
        {acao}
      </header>

      <FaixaEstado />

      <main className="conteudo">{children}</main>

      <nav className="barra-inferior" aria-label="Navegação principal">
        {/* Só aparece no desktop, onde o menu vira coluna e sobra espaço no topo. */}
        <div className="marca-lateral">
          <img src="/icone.svg" alt="" />
          <span>Controle de Veículos</span>
        </div>

        {ABAS.map((aba) => (
          <NavLink key={aba.para} to={aba.para} end={aba.para === '/'}>
            <Icone>{aba.icone}</Icone>
            {aba.rotulo}
          </NavLink>
        ))}
      </nav>
    </div>
  )
}
